<template>
    <div style="background:#d7d0c3">
        <div style="width:1400px; margin:0 auto; padding:10px 0; color:#f3efe7;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}" style="color:#7c838a">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item style="color:#918a7b">{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item style="color:#918a7b">{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="l30common_ctrl_container l30common" :style="{paddingTop:datas.board?0:'200px'}">
            <!-- board -->
            <div class="l30common_board_box" v-if="datas.board">
                <div class="l30common_board">
                    <div class="board-item-new" v-for="day in datas.board.oldresults?datas.board.oldresults:datas.board.results" :key="day">
                        <p class="dt">{{ day.day }}</p>
                        <template v-for="it in day.data">
                            <span class="board-item-span" :key="it.title">{{it.title}}：{{it.value}}</span>
                        </template>
                    </div>
                </div>
                <div class="tips">
                    <p v-for="t in datas.board.tips">{{ t }}</p>
                </div>
            </div>
            <!-- 表格 -->
            <div class="l30common_ctrl_tables" v-for="(it,index) in datas.results" :key="`table${index}`" >
                <div class="table_title">
                    <h2>{{ it.title }}</h2>
                </div>
                <DataTable :fields="it.thead" :datas="it.tbody" class="l30common_ctrl_table" :paging="false" />
                <div class="tips">
                    <p v-for="t in it.tips" :key="t">{{ t }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'l30index',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
    },
    mounted(){
        this.getData()
    },
    data() {
        return {
            datas: {
                results: [],
            },
            timer: {
                normal: null
            }
        }
    },
    methods: {
        getData() {
            this.loading = true
            this.$service.query(this.queryId, {}).then((data)=>{
                data.results.forEach((result)=>{
                    if(result.type=='pie') {
                        result.data.forEach((chart)=>{
                            chart.fields = chart.config.fields
                            chart.fields.push({'id':'ratio', 'suffix':'%'})
                            chart.text = {title:chart.config.title, num:chart.config.num}
                            chart.chart = {
                                type: 'pie',
                                x: { id:chart.config.name },
                                y: { id:chart.config.y},
                                label: true,
                                legend: false,
                                color: ['#7d203f','#982149','#861239','#a7345a','#c13e6a','#c55178','#bd5f7f','#c77591','#bb7f93','#d29bad','#e0b6c4'],
                                other: {innerRadius:0.8, labelStyle:{textStyle:{fill:'#fff'}}}
                            }
                        })
                    }
                });
                this.datas = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less">
.l30common_ctrl_table {
    .ant-table {
        background:#fefefe;
        color:#646464;
    }
    .ant-table-thead {
        border:none;
    }
    .ant-table-thead > tr > th {
        background: #7f8db4;
        color:#fff;
    }
    .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
        background:#dbceb7;
    }
    .ant-table-tbody > tr > td {
        border-color:#fff;
    }
    .ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
        color:#fff;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
        padding:5px 0;
    }
    .ant-table-tbody > tr:nth-child(2n) td{
        background:#eef1f7;
    }
    .ant-table-tbody > tr:hover td{
        background: #f1f1f1;
    }
    .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
        padding: 5px 0px;
    }
}
</style>
<style lang="less" scoped>
@width:1300px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.l30common_ctrl_container {
    min-height: 700px;
    .l30common_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .l30common_ctrl_title {
        position: absolute;
        
        width: 1140px;
        height: 135px;
        top:0;
        left: 50%;
        margin:100px 0 0 -570px;
        background: url('~@/assets/img/ctrl/d90/title.png') right no-repeat;
    }

    .l30common_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: @width;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #85929e; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:35%;
                    border-bottom: 1px solid #c5c8cc;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:35%;
                    border-bottom: 1px solid #c5c8cc;
                }
            }
        }
        .l30common_small_table {
            width:90%;
            margin:0 auto;
            font-size:13px;
            text-align: center;
            tr > th {
                background: #dcd0b9;
                color:#fff;
                padding:5px 5px;
            }
            tr > td {
                background:#374377;
                color:#fff;
                border-color:#7982ad;
                padding:5px 5px;
            }
            tr:nth-child(2n) td{
                background:#0b143e;
            }
        }
        .tips { color: #333; margin-top: 10px; text-align:center}
    }

    &.l30common {
        background: #eee5e6 url('~@/assets/img/ctrl/l30/bg.jpg') top center no-repeat;
        overflow:hidden;
        
        position: relative;
    }

    .l30common_board_box {
        width: 1300px;
        margin: 200px auto 50px;
        .tips {
            margin:20px 0 0 0px;
            text-align: center;
            color:  #7e8894;
        }
    }
    .l30common_board {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 70px 25px 30px;
        border: 1px solid #eee5e6;
        background: rgba(255, 255, 255, 0.2);

        .board-item-new {
        width:160px;
        min-height:150px;
        margin: 0 5px 20px 5px;
        padding:0 0 20px 0;
        background:rgba(255,255,255,0.4);
        color: #777;
        position: relative;
        display: inline-block;
        .dt {
            width: 100%;
            height: 45px;
            margin-bottom: 20px;
            margin-left: 0;
            background-color: #d7d0c3;
            color: #fff;
            font-size: 18px;
            line-height: 45px;
            text-align: center;
        }
        p {
            margin-left: 15px;
            margin-right: 15px;
            line-height:24px;
            color:#918a7b;
        }
        }
        .board-item-span{line-height:24px; color:#7e8894; display:block; padding:0 15px;}
        .tips { color: #8c9ac1; margin-top: 10px; text-align:center; 
            p{margin:0}
        }
    }
}
</style>